import Decimal from "decimal.js";
import Web3 from "web3";

const state = () => ({
    vault: {},
    tab: "DEPOSIT",
    contract: null,
    checkingToken: false,
    checkingApproval: true,
    hasToken: true,
    hasQueuedWithdrawls: false,
    approved: false,
    premiumLoad: false,
    vaultAtMaxBalance: false,
    ableToInitWithdraw: false,
    withdrawing: false,
    depositing: false,
    requesting: false,

    toogleUpdatedVault: false
});

const actions = {
    setVault(context, data) {
        context.commit("mutateState", { key: "vault", value: data });
    },
    setTab(context, data) {
        context.commit("mutateState", { key: "tab", value: data });
    },
    setData(context, { key, value }) {
        // console.log('setData',key,value);
        context.commit("mutateState", { key, value });
    },
    async initialize({ state, commit, dispatch }) {
        const contract = state.vault.contract_address;
        commit("mutateState", {
            key: "contract",
            value:
                contract.substring(0, 10) +
                "..." +
                contract.substring(contract.length - 4, contract.length)
        });

        await dispatch("checkAllowance");
        await dispatch("checkEpochWithdraw");
        dispatch("checkHasQueuedWithdrawls");

        commit("mutateState", {
            key: "vaultAtMaxBalance",
            value: await dispatch("isVaultAtMaxCap")
        });
    },

    async checkAllowance({ commit, state, rootState }) {
        commit("mutateState", { key: "checkingApproval", value: true });

        let token = rootState.wallet.tokens.find(
            item =>
                item.symbol == state.vault.real_token_symbol &&
                item.network == state.vault.network
        );
        if (token == undefined || !rootState.wallet.walletProvider) return;

        this.commit("wallet/setSelectedToken", {
            token: state.vault.real_token_symbol,
            network: state.vault.network
        });

        let res = await this.dispatch("vaults/checkAllowance", {
            contractAddress: state.vault.contract_address,
            token: token
        });

        if (+res > 0) {
            commit("mutateState", { key: "approved", value: true });
        } else {
            commit("mutateState", { key: "checkingApproval", value: false });
        }
    },
    async isVaultAtMaxCap({ state, rootState }) {
        let token = rootState.wallet.tokens.find(
            item => item.symbol == state.vault.token
        );
        if (token == undefined) return true;

        const currBalance = await this.dispatch(
            "vaults/getVaultCurrentDeposit",
            {
                vault_contract: state.vault.contract_address,
                token: token,
                vault: state.vault
            }
        );

        const decimals = token.decimals;
        if (currBalance / decimals >= state.vault.max_deposit) {
            return true;
        }

        return false;
    },
    async checkEpochWithdraw({ state, commit }) {
        // disable withdraw button, max withdraw amount button if there is a ongoing deposit
        if (
            (+state.vault.epoch >= state.vault.userInfo?.queuedEpoch ||
                +state.vault.queuedDeposits > 0 ||
                +state.vault.myPosition > 0) &&
            state.vault.pQueuedDeposits == 0
        ) {
            commit("mutateState", { key: "ableToInitWithdraw", value: true });
        } else {
            commit("mutateState", { key: "ableToInitWithdraw", value: false });
        }
    },
    checkHasQueuedWithdrawls({ state, commit }) {
        commit("mutateState", {
            key: "hasQueuedWithdrawls",
            value:
                state.vault.userInfo?.queuedWithdraw > 0 &&
                state.vault.userInfo?.exitQueueEpoch > 0
        });
    },

    //check vault type
    async checkVaultType({ rootState }, { vault }) {
        try {
            const web3 = new Web3(Web3.givenProvider || "ws://localhost:8545");
            Decimal.set({
                precision: 50,
                toExpPos: 50
            });

            const infoContract = new web3.eth.Contract(
                rootState.vaults.syn_abi,
                vault.contract_address
            );

            // console.log('infoContract',infoContract);

            const isExpiry =
                new Date(vault.vault_detail.expiry_timestamp * 1000) <
                new Date();
            const checkEpoch = vault.vault_detail.epoch + (isExpiry ? 1 : 0);
            const latest_type = +(await infoContract.methods
                .optionType(checkEpoch)
                .call());
            const type = latest_type === 1 ? "put_selling" : "covered_call";
            const real_token = vault.real_token_symbol;
            const reverse_token = vault.reverse_token_symbol;
            vault.type = type;

            let max_deposit, decimals;

            if (type === "put_selling") {
                max_deposit = +(await infoContract.methods
                    .collatCapQuote()
                    .call());
                decimals = +(await infoContract.methods
                    .QUOTE_DECIMALS()
                    .call());

                //if type == put -> change real token to reverse token
                vault.real_token_symbol = reverse_token;
                vault.reverse_token_symbol = real_token;
            } else {
                max_deposit = +(await infoContract.methods
                    .collatCap()
                    .call());
                decimals = +(await infoContract.methods
                    .BASE_DECIMALS()
                    .call());
            }

            vault.max_deposit = new Decimal(max_deposit)
                .div(`1e${decimals}`)
                .toNumber();

            //get expiry from vaultInfo
            const network = rootState.vaults.env.network[vault.network];
            const vaultContract = new web3.eth.Contract(
                rootState.vaults.ui_abi,
                network.contract
            );

            const vaultInfo = await vaultContract.methods
                .getVaultInfo(vault.contract_address)
                .call({ from: rootState.wallet.address });

            vault.expiry = vaultInfo.expiry;
            vault.vault_detail.expiry = new Date(
                vaultInfo.expiry * 1000
            ).toISOString();

            return vault;
        } catch (error) {
            return vault;
        }
    }
};

const mutations = {
    mutateState(state, { key, value }) {
        // console.log('MUTATE STATE', key, value);
        state[key] = value;
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};
